import axiosClient from "../../axios";

export async function getAllCategories({ commit }) {
    commit('setAllCategories', [true])

    return await axiosClient.get("/categories/all")
        .then((response) => {
            commit('setAllCategories', [false, response.data])
        })
        .catch(() => {
            commit('setAllCategories', [false])
        })
}

export async function getCategoryAttributes({ commit }, categoryId) {
    commit('setCategoryAttributes', [true])

    return await axiosClient.get(`/categories/${categoryId}/attributes`)
        .then((response) => {
            commit('setCategoryAttributes', [false, response.data])
        })
        .catch(() => {
            commit('setCategoryAttributes', [false])
        })
}

export async function getAllTags({ commit }) {
    commit('setAllTags', [true])

    return await axiosClient.get("/tags/all")
        .then((response) => {
            commit('setAllTags', [false, response.data])
        })
        .catch(() => {
            commit('setAllTags', [false])
        })
}

export function deleteGallery({ commit }, uuid) {
    return axiosClient.delete(`/products/gallery/${uuid}`)
}

export async function getProduct({ commit }, id) {
    return await axiosClient.get(`/products/${id}`)
}

export function updateProfileInfo({ commit }, { user }) {

    const form = new FormData();

    form.append('first_name', user.value.name);
    form.append('last_name', user.value.surname);
    form.append('email', user.value.email);
    form.append('phone_number', user.value.phone);


    form.append('_method', 'PUT');
    user = form;

    return axiosClient.post('/profile/edit', user)
}
